import React from 'react';

import { Box, DropdownSingleSelect, Input } from '@opendoor/bricks/core';

import { FEE_FREQUENCIES, FeeFrequency } from 'sellDirect/helpers/closingDash/constants';
import { HOAFee } from 'sellDirect/declarations/HOAFee';
import { sanitizeAndFormatNumberWithCommas } from '@opendoor/bricks/core/Input/helpers';

const HOA_FEE_ID = 'HOA fee amount';
const HOA_FREQUENCY_ID = 'HOA fee frequency';
/**
 * Renders the Hoa Fee input section for the HOA Details form
 *
 * component-test-check-ignore
 * storybook-check-ignore
 */
export const HoaFeeInput: React.FC<{
  index: number;
  updateHoaFeeAmount: (index: number, amount: number) => void;
  updateHoaFeeFrequency: (index: number, frequency: FeeFrequency) => void;
  fee: HOAFee;
  disabled: boolean;
}> = ({ index, updateHoaFeeAmount, updateHoaFeeFrequency, fee, disabled }) => {
  const AMOUNT = fee.amount ? (fee.amount / 100).toString() : '';
  return (
    <>
      <Input
        analyticsName="cake-hoa-fee-input-update-fee-amount"
        id={HOA_FEE_ID}
        onChange={(_event, value) => {
          if (value) {
            const sanitizedValue = sanitizeAndFormatNumberWithCommas(value).replaceAll(',', '');
            const valueAsNumber = parseInt(sanitizedValue);
            // If the customer enters just a string
            if (isNaN(valueAsNumber)) {
              updateHoaFeeAmount(index, 0);
            } else {
              updateHoaFeeAmount(index, valueAsNumber * 100);
            }
          } else {
            updateHoaFeeAmount(index, 0);
          }
        }}
        disabled={disabled}
        type="currency"
        unboundedWidth
        placeholder="$ ###"
        label={HOA_FEE_ID}
        required
        value={AMOUNT}
        data-testid={HOA_FEE_ID}
      />

      <DropdownSingleSelect
        title={
          <Box as="span">
            {HOA_FREQUENCY_ID}
            <Box as="span" ml={1} aria-hidden color="red50">
              *
            </Box>
          </Box>
        }
        inputId={HOA_FREQUENCY_ID}
        aria-labelledby={HOA_FREQUENCY_ID}
        name={HOA_FREQUENCY_ID}
        autoComplete="off"
        onChange={(value) => {
          if (typeof value === 'string') {
            updateHoaFeeFrequency(index, value as FeeFrequency);
          }
        }}
        options={FEE_FREQUENCIES.map((frequency) => ({ label: frequency, value: frequency }))}
        selectedValue={[fee.frequency as string]}
        isDisabled={disabled}
      />
    </>
  );
};
